import React from 'react';
import { QuizLocationDialog } from '../../components/compositions';
import TeacherToolCard from '../../components/compositions/TeacherToolCard/TeacherToolCard';
import TeacherLayoutWrapper from '../../components/layouts/TeacherLayoutWrapper/TeacherLayoutWrapper';
import TeacherPageHeader from '../../components/layouts/TeacherPageHeader/TeacherPageHeader';
import './teacher-tools-view.scss';
import useTeacherToolsView from './useTeacherToolsView';

const TeacherToolsView = () => {
  const { isQuizDialogOpen, onCloseQuizDialog, onToolClick, t, tools } = useTeacherToolsView();

  return (
    <TeacherLayoutWrapper
      activeNavigationId="tools"
      className="teacher-tools-view"
      gutter="standard"
      header={<TeacherPageHeader robot="help" subtitle={t('teacher_tools_description')} title={t('teacher_tools_title')} variant="title" />}
    >
      <div className="teacher-tools-view__content">
        {/* Tools Grid */}
        <div className="teacher-tools-view__grid">
          {tools.map((tool) => (
            <TeacherToolCard key={tool.id} tool={tool} onClick={onToolClick} />
          ))}
        </div>
      </div>

      {/* Quiz Location Dialog */}
      <QuizLocationDialog isOpen={isQuizDialogOpen} onClose={onCloseQuizDialog} />
    </TeacherLayoutWrapper>
  );
};

export default TeacherToolsView;
